import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../Redux/Slices/Utility/LoginSlice";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import "./Login.css";
import loginImage from "../../Asset/Image/Login/Login.png";
import { FaFacebookF, FaGoogle, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { Alert } from "react-bootstrap";
import { IoMdEyeOff } from "react-icons/io";
import { IoEye } from "react-icons/io5";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Correctly named as navigate for clarity
  const [rememberMe, setRememberMe] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => setShowPassword(prev => !prev);

  let UserLogin = useSelector((state) => state.UserLogin);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {

    if (rememberMe) {
      localStorage.setItem("rememberLogin", btoa(JSON.stringify({ userName: data.Username, Password: btoa(data.Password) })));
    } else {
      localStorage.removeItem("rememberLogin");
    }
    await dispatch(loginUser(data, navigate));
  };

  let Setting = useSelector(state => state.Setting.Setting);
  let CompCode = Setting?.find(Setting => Setting.SKEY === 'COMP_CODE')?.SVALUE;

  useEffect(() => {
    // if (UserLogin.user && UserLogin.isAuthenticated === true) { 
    //   dispatch(fetchMenuPermition())
    //   navigate("/");
    // }
    // if (UserLogin.user && UserLogin.isAuthenticated === true) {
    //   dispatch(fetchMenuPermition())
    //   navigate("/");
    // }


    if (UserLogin.user) {
      if (CompCode === "Valam" || CompCode === "SILVER") {
        navigate('/AccountMast');
      } else {
        navigate('/');
      }
    }

  }, [UserLogin]);

  // const handleForgotPassword = async (email) => {
  //   dispatch(forgotPassword(email));
  // };

  useEffect(() => {
    let storedUserdata = localStorage?.getItem("rememberLogin");
    if (storedUserdata) {
      storedUserdata = JSON.parse(atob(storedUserdata))
      setValue("Username", storedUserdata.userName);
      setValue("Password", atob(storedUserdata.Password));
      setRememberMe(true); // Assuming you want to check the checkbox if the username is remembered
    }
  }, [UserLogin]);

  return (
    <>
      <div className="container-fluid login_container">
        <form onSubmit={handleSubmit(onSubmit)} className="login-container">
          <div className="login-box">
            <div className="mb-3">
              <input
                type="Text"
                placeholder="Username"
                className="form-control input-login"
                name="Username"
                {...register("Username", {
                  required: "This field is required",
                })}
              />
              {errors.Username && (
                <span className="validation">{errors.Username.message}</span>
              )}
            </div>
            <div className="mb-3 position-relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                className="form-control pe-5"
                name="Password"
                {...register("Password", {
                  required: "This field is required",
                })}
              />

              <span
                className="position-absolute top-50 end-0 translate-middle-y me-3"
                onClick={togglePasswordVisibility}
                style={{ cursor: "pointer", fontSize: "1.2rem", color: "#6c757d" }}
              >
                {showPassword ? <IoMdEyeOff /> : <IoEye />}
              </span>
               
              {errors.Password && (
                <span className="validation">{errors.Password.message}</span>
              )}
                
              <span
                className="position-absolute top-50 end-0 translate-middle-y me-3"
                onClick={togglePasswordVisibility}
                style={{ cursor: "pointer", fontSize: "1.2rem" }}
              >
                {showPassword ? <IoMdEyeOff /> : <IoEye />}
              </span>
            </div>
            <div>
              <span className="chekbox text-lg-start">
                <input
                  type="checkbox"
                  id="rememberMe"
                  name="rememberMe"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  className="mx-1"
                ></input>
                <label htmlFor="rememberMe">Remember Me</label>
              </span>
            </div>

            <button
              className="btn-sm btn-login ml-md-2 w-100 my-2"
              type="submit"
            >
              Log in
            </button>

            <hr />
            <Link
              to="/Register"
              style={{ color: "#337357", fontWeight: "700" }}
            >
              <div className=" text-center w-100">
                <button
                  className="btn-sm ml-md-2 w-75 btnlog-create"
                  type="submit" >
                  Create new account
                </button>
              </div>
            </Link>
              
            <Alert
              variant="success"
              show={showAlert}
              onClose={() => setShowAlert(false)}
              dismissible
            >
              Password reset email sent!
            </Alert>
          </div>
        </form>
      </div>
    </>
  );
}
export default Login;
